var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.778 1h12.444c.207 0 .404.083.55.231.146.149.228.35.228.56v1.252c0 .21-.082.41-.228.559L9.783 8.67a.796.796 0 00-.227.558v4.982a.801.801 0 01-.3.623.773.773 0 01-.667.143l-1.556-.395a.777.777 0 01-.424-.28.798.798 0 01-.165-.486V9.228c0-.21-.082-.41-.227-.558l-4.99-5.068A.796.796 0 011 3.043V1.79c0-.21.082-.41.228-.559A.772.772 0 011.778 1z",
    stroke: "#757779",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFilterinline;